var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadiconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5849 7.44981V9.70261C11.5849 10.0013 11.4662 10.2879 11.255 10.4991C11.0437 10.7103 10.7572 10.829 10.4585 10.829H2.57367C2.27493 10.829 1.98842 10.7103 1.77718 10.4991C1.56594 10.2879 1.44727 10.0013 1.44727 9.70261V7.44981M3.70007 4.63381L6.51607 7.44981M6.51607 7.44981L9.33207 4.63381M6.51607 7.44981V0.691406",
    stroke: "white",
    strokeWidth: 1.01376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadiconnew);
export default __webpack_public_path__ + "static/media/downloadiconnew.cd58b0a1172dfcdf6fb887ec3ec95ffb.svg";
export { ForwardRef as ReactComponent };